export default __webpack_public_path__ + "audio/fef815e90fbcf62be22ce4734e63d91f.mp3";